import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _debounce from 'lodash/debounce';
import Dropdown, {
  DropdownContent,
  DropdownTrigger,
} from 'react-simple-dropdown';
import cn from 'classnames';
import _isEqual from 'lodash/isEqual';
import Tooltip from '@omilia/tooltip';

import { paginationOptionsType } from 'types';

import DropdownItem from 'components/DropdownItem';

import EntriesSorter from '../EntriesSorter';
import './style.scss';

class TableHeadColumn extends Component {
  static propTypes = {
    col: PropTypes.shape({
      name: PropTypes.string,
      archived: PropTypes.bool,
      order: PropTypes.number,
    }),
    isLoadingEntries: PropTypes.bool,
    onUpdateCol: PropTypes.func.isRequired,
    onSaveNewColumn: PropTypes.func.isRequired,
    onSaveColumnUpdate: PropTypes.func,
    onDeleteColumn: PropTypes.func.isRequired,
    sortItems: PropTypes.func.isRequired,
    entriesPagination: paginationOptionsType,
  };

  constructor(props) {
    super(props);

    this.state = {
      rename: false,
    };

    this.save = _debounce(this.saveColumn, 150);
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.rename && !_isEqual(nextProps.col, this.props.col)) {
      this.setState({
        rename: false,
      });
    }
  }

  transformNumberToLetter = orderNum =>
    `${String.fromCharCode(orderNum + 1 + 'A'.charCodeAt(0))}.`;

  handleUpdateCol = ({ target: { value } }) => {
    const { col } = this.props;
    if (!value) {
      this.props.onDeleteColumn(col);
    } else if (value && value !== col.name) {
      this.props.onUpdateCol(col, value);
      this.save();
    } else {
      this.setState({
        rename: false,
      });
    }
  };

  saveColumn = () => {
    const { col } = this.props;
    if (col.id) {
      this.props.onSaveColumnUpdate(col.id, col);
    } else {
      this.props.onSaveNewColumn(col);
    }
  };

  handleRename = () => {
    this.setState({
      rename: true,
    });

    this.dropdown.hide();
  };

  handleDelete = () => {
    this.props.onDeleteColumn(this.props.col);
  };

  handleKeyDown = e => {
    if (e.keyCode === 13) {
      this.handleUpdateCol(e);
    }
  };

  handleRefDropdown = el => {
    this.dropdown = el;
  };

  renderArchived = () => {
    const { name, order } = this.props.col;

    return (
      <th styleName="root">
        <div styleName="inner">
          <span styleName="order">{this.transformNumberToLetter(order)}</span>
          {name}
          <div styleName="menu-wrap">
            <Tooltip content="Archived Column">
              <i className="icon-archived" data-test="column-archived" />
            </Tooltip>
          </div>
        </div>
      </th>
    );
  };

  render() {
    const { col, isLoadingEntries, entriesPagination } = this.props;
    const { id, order, name } = col;
    const { rename } = this.state;

    /* eslint-disable jsx-a11y/no-autofocus */

    if (col.archived) {
      return this.renderArchived();
    }

    return (
      <th styleName="root">
        <div styleName="inner" data-test="column">
          <span styleName="order">{this.transformNumberToLetter(order)}</span>

          {!id || rename ? (
            <input
              autoFocus
              onKeyDown={this.handleKeyDown}
              defaultValue={name}
              onBlur={this.handleUpdateCol}
              data-test="column-name"
            />
          ) : (
            name
          )}

          <EntriesSorter
            id={col.id}
            tooltipEnding="this feature"
            isLoadingEntries={isLoadingEntries}
            onSort={this.props.sortItems}
            sortBy={entriesPagination}
          />

          <Dropdown styleName="menu-wrap" ref={this.handleRefDropdown}>
            <DropdownTrigger
              styleName={cn('toggle')}
              data-test="column-options"
            >
              <i className="icon-options" />
            </DropdownTrigger>

            <DropdownContent>
              <DropdownItem
                onClick={this.handleRename}
                data-test="rename-column"
              >
                Rename
              </DropdownItem>
              <DropdownItem
                isDanger
                onClick={this.handleDelete}
                data-test="delete-column"
              >
                Archive
              </DropdownItem>
            </DropdownContent>
          </Dropdown>
        </div>
      </th>
    );
  }
}

export default TableHeadColumn;
